import {
    initMain
} from './vue/controllers/main';
import {
    header
} from './vue/controllers/header';
import {
    TextFill,
    tfmixin
} from './vue/components/text-fill/TextFill.vue';
import lazyload from './features/lazy-load';
import proportionalScroll from './features/proportional-scroll';
import {
    galleryMixin
} from './features/gallery';
import {
    postMixin
} from './vue/mixins/lrplus';
import mostviewed from './features/most-viewed';
import {
    scrollFixedMixin
} from './features/scroll-fixed';

mostviewed();
lazyload();
proportionalScroll();
const mixins = [tfmixin, galleryMixin, postMixin, scrollFixedMixin];
initMain(mixins, {
    TextFill,
    SubscribeModal: () => import('./vue/components/subscribe-modal/SubscribeModal.vue'),
    FavoriteAddButton: () => import('./vue/components/favorite-add-button/FavoriteAddButton.vue'),
    InterestNews: () => import('./vue/components/interest-news/InterestNews.vue'),
}, []);
header();